import * as React from 'react';
import cx from 'classnames';
import { observer } from 'mobx-react';
import useStore from '@src/utils/hooks/use-store';
import SectIntroductionStore from '@src/pages/main/components/sect-introduction/store';
import aos from '@src/utils/aos';
import Link from '@src/components/link';
import SimpleSwiper from '@src/components/swiper/simple-swiper';
const styles = require('./index.less');

const SectIntroduction = () => {
  const store = useStore(() => new SectIntroductionStore());
  return (
    <div className={styles.root}>
      <div className={styles.sect}>
        <div className={styles.sect_title} {...aos.FADE_DOWN()} />
        <div className={cx(styles.sect_content)} {...aos.FADE_UP()}>
          <SimpleSwiper params={store.params}>
            {Object.keys(store.sectList).map((item, index) => {
              return (
                <div className={cx(styles.sect_item, styles[item])} key={index}>
                  <div className={store.realIndex === index ? styles.active : null}>
                    <img className={cx(styles.title, styles.ani_left)} src={store.sectList[item].title} alt="" />
                    <img className={cx(styles.subTitle, styles.ani_left)} src={store.sectList[item].subTitle} alt="" />
                    <img className={cx(styles.radar, styles.ani_left)} src={store.sectList[item].radar} alt="" />
                    <img className={cx(styles.desc_title, styles.ani_right)} src={require('./images/sect-desc-title.png')} alt="" />
                    <img className={cx(styles.desc, styles.ani_right)} src={store.sectList[item].desc} alt="" />
                    <img className={cx(styles.weapon, styles.ani_right)} src={store.sectList[item].weapon} alt="" />
                    {store.sectList[item].videoUrl && (
                      <div className={cx(styles.video_Box, styles.ani_right)}>
                        <Link className={styles.btn_sect_play} onClick={() => store.showSectPlay(store.sectList[item].videoUrl)} />
                        <div className={styles.btn_sect_text} />
                      </div>
                    )}

                    <img className={cx(styles.role, styles.ani_bottom)} src={store.sectList[item].role} alt="" />
                    {/* <img className={cx(styles.role, styles.ani_bottom)} src={require('./images/wudu/wu_du_ren_wu.png')} alt="" /> */}
                  </div>
                </div>
              );
            })}
          </SimpleSwiper>
          <div className={styles.sect_swiper_btns}>
            <Link className={styles.btn_sect_prev} onClick={() => store.changeSwiper('prev')} />
            <Link className={styles.btn_sect_next} onClick={() => store.changeSwiper('next')} />
          </div>
          <div className={styles.sect_pagination}>
            {Object.keys(store.sectList).map((item, index) => {
              return (
                <Link className={styles.sect_pagination_item} key={index} onClick={() => store.changeSwiper(index)}>
                  <img src={store.sectList[item].pagination} alt="" className={store.realIndex !== index ? styles.showImg : null} />
                  <img src={store.sectList[item].paginationAcitve} alt="" className={store.realIndex === index ? styles.showImg : null} />
                </Link>
              );
            })}
          </div>
        </div>
      </div>
    </div>
  );
};

export default observer(SectIntroduction);
